<template>
  <section id="BroncosPlus">
    <b-container>
      <div class="broncosPlus-cnt">
        <div class="my-content plus">
          <div class="content split">
            <div class="block left">
              <div class="bp-title-cnt">
                <img src="@/assets/broncos-plus.png" />
              </div>
              
              <div class="broncos-plus-text">Exclusive to Broncos Season Ticket Members, Broncos Plus is a free initiative geared towards rewarding our most passionate fans for their unwavering support and loyalty to the team.<br /><br />Broncos Plus allows fans to "plus up" their gameday by unlocking exclusive rewards and a 20% discount on food and beverage at stadium concessions stands and merchandise at the team store.</div>
				
              <div class="savings-cnt">
                <div class="savings-left">
                  <img src="@/assets/svgs/savings-icon.svg" alt="Savings Icon">
                </div>
                <div class="savings-right">
                  <p>To date, Season Ticket Members have <span class="orange">saved over $1,000,000</span> by utilizing their Broncos Plus card at game day concessions & merchandise.</p>
                </div>
              </div>
            </div>
            <div class="block right">
              <div class="phone-cnt">
                <img src="@/assets/iphone-white.png" class="phone">
                <div class="phone-name">Steve <span>Atwater</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "BroncosPlus"
  }
</script>

<style lang="scss" scoped>
  @mixin flexCenter {justify-content:center; align-items:center;}
  @mixin backCover {background-position:center center; background-repeat:no-repeat; background-size:cover;}

  $cw: 1000px;
  $cwHalf: 500px;
  $mw: 880px;

  #BroncosPlus {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 75px 0px 100px;
    background: url('~@/assets/bg/bg-broncos-plus.png') scroll no-repeat top right $orange;
    background-size: auto 100%;
    .broncosPlus-cnt {
      div.my-content.plus {
				div.content {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          max-width: 1000px;
          margin: 0 auto;
          div.block.left {
            position: relative;
            width: 100%;
            max-width: 600px;
            .bp-title-cnt {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 299px;
              height: 118px;
              background: url('~@/assets/svgs/broncos-plus-img-bg.svg') scroll no-repeat center center;
              background-size: 299px 118px;
              img {
                width: 194px;
              }
            }
            .broncos-plus-text {
                margin: 15px 0 20px;
                font-size: 13px;
                @include nexaBold;
                line-height: 18px;
                color: $white;
              }
              .savings-cnt {
                position: relative;
                display: flex;
                align-items: center;
                width: 100%;
                .savings-left {
                  display: inline-flex;
                  margin-right: 25px;
                  img {
                    width: 62px;
                  }
                }
                .savings-right {
                  display: inline-flex;
                  width: calc(100% - 87px);
                  p {
                    font-size: 13px;
                    @include nexaBold;
                    line-height: 18px;
                    color: $white;
                    span {
                      display: block;
                      font-size: 37px;
                      line-height: 48px;
                      text-transform: uppercase;
                      color: #092244;
                    }
                  }
                }
              }
          }
          div.block.right {
            .phone-cnt {
              position: absolute;
              top: -58px;
              width: 100%;
              max-width: 318px;
              img.phone {
                position: relative;
                display: inline-flex;
                width: 100%;
                max-width: 318px;
              }
              .phone-name {
                position: absolute;
                top: 200px;
                left: 50%;
                width: 150px;
                font-size: 23px;
                @include nexaBold;
                line-height: 22px;
                text-align: center;
                text-transform: uppercase;
                color: $white;
                @include transform(translateX(-50%));
                span {
                  display: block;
                }
              }
            }
          }
				}
			}
    }
  }
</style>